import { Reducer } from "redux";
import { ANALYTICS_FAIL, ANALYTICS_REQUEST, ANALYTICS_SUCCESS } from "../constants/analyticsConstants";
import { ILoan } from "../factory/interfaces";
import { LOANS_FAIL, LOANS_REQUEST, LOANS_SUCCESS } from "../constants/loansConstants";


interface analyticsState {
    data: {
        success: boolean,
        message: string,
        loans: ILoan[]
    }
  
}
const initialState : analyticsState = {
    data: {
        success: false,
        message: 'Loading loans...',
        loans: []

    }

}

const loansReducer: Reducer<analyticsState> = (state = initialState, action)=>{

    switch(action.type){
        case LOANS_REQUEST:
            return {data: initialState}
        case LOANS_SUCCESS:
            return {data: action.payload}
        
        case LOANS_FAIL:
            return{
                data: initialState,
            }
        default:
        return state
    }

}

export default loansReducer